import React from 'react';

interface AppointmentButtonProps {
  className?: string;
  text?: string;
}

export const WHATSAPP_URL = "https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!%20Me%20gustar%C3%ADa%20pedir%20cita%20para%20un%20servicio";

export function AppointmentButton({ className = "", text = "CITA PREVIA" }: AppointmentButtonProps) {
  return (
    <a 
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`block text-center px-4 py-1.5 rounded-full transition-colors ${className}`}
    >
      {text}
    </a>
  );
}